import React, { useState, useEffect, useRef } from 'react';

const AboutSection = () => {


    return (
        <section className="relative py-24 overflow-hidden bg-black">
            {/* Elegant Background with Fabric-like Texture */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                {/* Main black fabric background */}
                <div className="absolute inset-0 bg-black"></div>

                {/* Subtle fabric folds with gold accents - using rounded shapes */}
                <div className="absolute top-0 right-0 w-full h-[60%] bg-gradient-to-bl from-amber-900/28 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute bottom-[30%] left-0 w-[70%] h-[50%] bg-gradient-to-tr from-amber-800/25 to-transparent rounded-full blur-2xl"></div>

                {/* Elegant gold accent curves - circular forms */}
                <div className="absolute top-[15%] left-[12%] w-[30%] h-[30%] bg-gradient-to-br from-amber-700/35 via-amber-600/20 to-transparent rounded-full blur-xl"></div>
                <div className="absolute bottom-[20%] right-[15%] w-[25%] h-[25%] bg-gradient-to-tl from-amber-700/30 to-transparent rounded-full blur-lg"></div>

                {/* Additional soft circular accents */}
                <div className="absolute top-[50%] left-[60%] w-[20%] h-[20%] bg-gradient-to-br from-amber-600/25 to-transparent rounded-full blur-xl"></div>
                <div className="absolute bottom-[60%] right-[40%] w-[35%] h-[35%] bg-gradient-to-tl from-amber-800/22 to-transparent rounded-full blur-2xl"></div>

                {/* More golden richness */}
                <div className="absolute top-[70%] right-[10%] w-[18%] h-[18%] bg-gradient-to-br from-amber-500/22 to-transparent rounded-full blur-lg"></div>
                <div className="absolute bottom-[10%] left-[30%] w-[20%] h-[20%] bg-gradient-to-tl from-amber-600/18 to-transparent rounded-full blur-xl"></div>

                {/* Silk-like sheen - large soft circle */}
                <div className="absolute top-[30%] right-[25%] w-[60%] h-[50%] bg-gradient-to-bl from-amber-700/18 via-amber-500/25 to-transparent rounded-full blur-3xl"></div>
            </div>
            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    {/* Text Content */}
                    <div className={`transform transition-all duration-1000`}>
                        <div className="mb-8 lg:mb-10">
                            <div className="inline-flex items-center space-x-2 lg:space-x-3 bg-black/60 backdrop-blur-sm px-4 lg:px-8 py-2 lg:py-3 rounded-full border border-yellow-700 shadow-lg mb-6 lg:mb-8">
                                <div className="w-2 h-2 bg-primary rounded-full"></div>
                                <span className="text-primary font-medium tracking-widest text-xs lg:text-sm uppercase">
                                    Nuestra Historia
                                </span>
                            </div>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-thin text-white leading-tight mb-4 lg:mb-6">
                                Excelencia en
                                <span className="text-primary font-light block"> Educación Profesional</span>
                            </h2>
                            <div className="w-16 lg:w-24 h-1 bg-gradient-to-r from-primary to-primary-dark rounded-full"></div>
                        </div>

                        <div className="space-y-6 lg:space-y-8 text-stone-300 leading-relaxed">
                            <div className="bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 lg:p-8 border border-stone-700 shadow-lg">
                                <p className="text-base lg:text-lg font-light leading-relaxed">
                                    En <span className="text-primary font-medium">Escuela Verónica Dandrea</span>, nacimos del sueño de transformar
                                    la educación en belleza y estética profesional. Fundada con la visión de formar verdaderos artistas de la belleza,
                                    hemos construido un legado de excelencia que trasciende las aulas, creando profesionales que marcan la diferencia
                                    en la industria.
                                </p>
                            </div>

                            <div className="bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 lg:p-8 border border-yellow-800 shadow-lg">
                                <p className="text-base lg:text-lg font-light leading-relaxed">
                                    Nuestra misión es clara: empoderar a cada estudiante con conocimientos técnicos de vanguardia,
                                    creatividad sin límites y la confianza necesaria para destacar en el competitivo mundo de la belleza.
                                    Creemos que cada graduada lleva consigo no solo habilidades, sino una pasión que transforma vidas.
                                </p>
                            </div>

                            <div className="bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 lg:p-8 border border-stone-700 shadow-lg">
                                <p className="text-base lg:text-lg font-light leading-relaxed">
                                    Contamos con <span className="text-primary font-medium">salones de práctica profesional</span> y un equipo docente de élite que combina experiencia internacional
                                    con una pasión genuina por enseñar y formar futuras líderes de la industria.
                                </p>
                            </div>
                        </div>

                        {/* Professional Stats */}
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6 mt-10 lg:mt-12">
                            <div className="text-center bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-primary shadow-lg group hover:shadow-xl transition-all duration-300">
                                <div className="text-3xl lg:text-4xl font-light text-primary mb-2">30000+</div>
                                <div className="text-xs lg:text-sm text-stone-400 uppercase tracking-wide font-medium">Graduadas Exitosas</div>
                            </div>
                            <div className="text-center bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-stone-700 shadow-lg group hover:shadow-xl transition-all duration-300">
                                <div className="text-3xl lg:text-4xl font-light text-primary mb-2">10+</div>
                                <div className="text-xs lg:text-sm text-stone-400 uppercase tracking-wide font-medium">Años de Experiencia</div>
                            </div>
                            <div className="text-center bg-black/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-primary shadow-lg group hover:shadow-xl transition-all duration-300">
                                <div className="text-3xl lg:text-4xl font-light text-primary mb-2">10+</div>
                                <div className="text-xs lg:text-sm text-stone-400 uppercase tracking-wide font-medium">Especialidades</div>
                            </div>
                        </div>
                    </div>

                    {/* Image Content */}
                        <div className={`transform transition-all duration-1000 delay-300 mt-12 lg:mt-0`}>
                        <div className="relative px-4 lg:px-0">
                            {/* Main Image */}
                            <div className="relative overflow-hidden rounded-2xl lg:rounded-3xl shadow-2xl">
                                <img
                                    src={require('../assets/imagenes/generales/fotoEscuelaMain.png')}
                                    alt="Estudiantes en clase de estética"
                                    className="w-full h-64 lg:h-96 object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent"></div>
                            </div>

                            {/* Professional Floating Card */}
                            <div className="absolute bottom-4 right-4 lg:bottom-6 lg:right-6 bg-black/80 backdrop-blur-sm p-3 lg:p-4 rounded-xl shadow-xl max-w-xs border border-yellow-800">
                                <div className="text-stone-300">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-8 lg:w-10 h-8 lg:h-10 bg-gradient-to-br from-yellow-600 to-amber-500 rounded-lg flex items-center justify-center">
                                            <svg className="w-4 lg:w-5 h-4 lg:h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-primary text-sm lg:text-base">Certificación Profesional</h4>
                                            <p className="text-xs lg:text-sm text-stone-400 font-light">
                                                Títulos reconocidos
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Professional Decorative Elements - Hidden on mobile */}
                            <div className="hidden lg:block absolute -top-4 -right-4 w-28 h-28 border-2 border-yellow-700/40 rounded-3xl"></div>
                            <div className="hidden lg:block absolute top-8 -right-8 w-20 h-20 bg-gradient-to-br from-yellow-600/40 to-amber-500/40 rounded-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection; 